import { useEffect } from 'react';
import { useMlbb } from '../mlbb/store';
import { buildNovaBracket, buildNovaSchedule, hasNovaGroups, isDotaTournament } from '../mlbb/novaBracketEngine';

export function completedBracketMatches(tour, results = {}) {
  if (!hasNovaGroups(tour)) return [];
  try {
    const bracket = buildNovaBracket(tour.groups, results, {
      preliminary: tour.bracketPreliminary === true, playoffSeeds: tour.playoffSeeds,
    });
    return buildNovaSchedule(bracket, tour.matchSchedule).filter((match) => match.completed === true)
      .map((match) => ({ ...match, teamA: bracket.names[match.a] || match.aSource.label,
        teamB: bracket.names[match.b] || match.bSource.label }));
  } catch { return []; }
}

export default function CompletedBracketMatches({ tour }) {
  const { results, tourId, startPolling } = useMlbb();
  const game = isDotaTournament(tour) ? 'dota2' : 'cs2';
  useEffect(() => {
    if (hasNovaGroups(tour)) return startPolling(tour.id, game);
  }, [tour.id, game, startPolling]); // eslint-disable-line react-hooks/exhaustive-deps
  const matches = completedBracketMatches(tour, tourId === tour.id ? results : {});
  if (!hasNovaGroups(tour)) return null;
  return <section className="rounded-2xl border border-line bg-surface-2 p-5 mb-5" aria-label="Прошедшие матчи">
    <h3 className="font-display font-bold uppercase text-xl mb-4">Прошедшие матчи</h3>
    {!matches.length ? <p className="text-fg-muted">Прошедших матчей пока нет.</p> : <div className="overflow-x-auto">
      <table className="fed-tbl">
        <thead><tr><th>Дата / день</th><th>Время (UTC+5)</th><th>Матч</th><th>Команды</th><th>Счёт</th></tr></thead>
        <tbody>{matches.map((match) => <tr key={match.id}>
          <td>{match.date || `День ${match.day}`}</td><td>{match.time}</td>
          <td>{match.group ? `Группа ${match.group} · ` : ''}{match.label}</td>
          <td>{match.teamA} — {match.teamB}</td>
          <td>{match.sa === '' && match.sb === '' ? 'Не указан' : `${match.sa} : ${match.sb}`}</td>
        </tr>)}</tbody>
      </table>
    </div>}
  </section>;
}
